import { ShoppingCartOutlined, TagOutlined } from '@ant-design/icons'
import { Avatar, Badge } from 'antd'
import React, { useContext, useState } from 'react'
import ModalMenuItem from '../ModalMenuItem/ModalMenuItem';
import { MenuItem } from '../../Models/ModalItem';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import CartDetailComponent from '../CartDetailComponent/CartDetailComponent';
import { Monitor } from '../../Models/Monitor';
import { addMonitor } from '../../Api/Monitor';
// import ModalMenuItem from '../ModalMenuItem/ModalMenuItem';
// import ListCardComponentPokemon from '../ListCardComponent/ListCardComponentPokemon';
// import CartDetailComponent from '../CartDetailComponent/CartDetailComponent';
// import { PromiseSesionContext } from '../../Machines/SesionMachine';

const CartComponent = () => {
    const [open, setOpen] = useState<boolean>(false);
    const {error, sendError} = useContext(PromiseSesionContext);
    const {cart, sendCart, cartCard} = useContext(PromiseSesionContext);

    let menuItem:MenuItem =   {
        label: <span></span>,
        title: "",
        key: '1',
        icon: <TagOutlined />,
        component: <CartDetailComponent />,
        // component: <></>,
        type: 'CONTENT',
        items: [],
        size: 'small',
        onConfirm: () => {},
    
      }
    
        const sendMonitor = async ()=>{
          try{

          
            let user:string= localStorage.getItem("user") || ""
  
            let monitor:Monitor={
                action:`Abrio carrito de compras`,
                user:user
            }
            await addMonitor(monitor)
          }
        catch(error){
 
        }
        }
        
  return (
    <>
    <Badge color='#D84E64' count={(cart.context.cart.nProducts + cartCard.context.cart.nProducts)}>
      <Avatar onClick={()=>{setOpen(true); sendMonitor()}} shape="square" size="large" icon={<ShoppingCartOutlined />} style={{ backgroundColor: 'transparent', color: '#fff', cursor:"pointer"}} />
    </Badge>

    <ModalMenuItem menuItem={menuItem} open={open} setOpen={setOpen} updateSize />

    </>
  )
}

export default CartComponent